<template lang="html">
  <div class="loading" :style="'height: '+ height">
    <div class="inside" :style="'height: '+ height">
      <div id="loading-bar-spinner" class="spinner"><div class="spinner-icon"></div></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    height: {
      type: String,
      default: null // Opciones disponibles: 'vh-100' => 'todo el alto de pantalla'
    },
  },
}
</script>
